import { TPopupFormData } from 'src/@types';
import { IPopupSFilter } from 'src/@types/SearchFilterTypes';
import { IPopup } from 'src/models/management/popup/Popup';
import { TApiResponseData } from 'src/service/apiTypes';
import instance from 'src/service/axios';
import objectToQueryString from 'src/utils/objectToQueryString';

const SUB_URL = '/v1/popup';
/**
 * 팝업 목록 조회
 */
export const getPopup = async (pageParams: IPopupSFilter) => {
  try {
    const url = SUB_URL + objectToQueryString(pageParams);
    const response = await instance.get<TApiResponseData<IPopup[]>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        data: response.data.data,
        pagination: response.data.pagination,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 팝업 상세 조회
 */
export const getDetail = async (popupSid: number) => {
  try {
    const url = `${SUB_URL}/${popupSid}`;
    const response = await instance.get<TApiResponseData<IPopup>>(url);
    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 팝업 등록
 */
export const post = async (data: TPopupFormData) => {
  try {
    const url = `${SUB_URL}`;

    const response = await instance.post<TApiResponseData<IPopup>>(url, data);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 팝업 수정
 */
export const put = async (popupSid: number, data: TPopupFormData) => {
  try {
    const url = `${SUB_URL}/${popupSid}`;

    const response = await instance.put<TApiResponseData<IPopup>>(url, data);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 팝업 삭제
 */
export const remove = async (popupSid: number) => {
  try {
    const url = `${SUB_URL}/${popupSid}`;
    const response = await instance.delete<TApiResponseData<IPopup>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};
